import { render } from "./TasksDashboard.vue?vue&type=template&id=162f1c8e"
import script from "./TasksDashboard.vue?vue&type=script&lang=js"
export * from "./TasksDashboard.vue?vue&type=script&lang=js"

import "./TasksDashboard.vue?vue&type=style&index=0&id=162f1c8e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__